<template>
  <v-dialog v-model="show" max-width="600px">
    <v-card>
      <v-card-title class="text-center" style="justify-content: center; word-break: break-word">
        {{ $t('triggersHistories.confirmationRelaunch') }}
      </v-card-title>
      <v-card-text class="pb-0">{{ $t('triggersHistories.confirmationRelaunchText') }}</v-card-text>
      <v-container fluid>
        <v-switch v-if="displayGetEntityToRetryButton" dense hide-details v-model="getEntityToRetry">
          <template v-slot:label>
            <v-card-text class="input__label pa-0">
              {{ $t('triggersHistories.getEntityToRetry') }}
            </v-card-text>
          </template>
        </v-switch>
        <v-switch dense hide-details v-model="checkConditions">
          <template v-slot:label>
            <v-card-text class="input__label pa-0">
              {{ $t('triggersHistories.checkConditions') }}
            </v-card-text>
          </template>
        </v-switch>
      </v-container>
      <v-card-actions class="pa-0 mt-4">
        <v-btn color="primary" tile @click="validate()" style="width: 50%">{{ $t('subOrder.confirm') }}</v-btn>
        <v-btn color="secondary" tile class="ml-0" style="width: 50%" @click="close()">
          {{ $t('subOrder.close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'ConfirmationRetryTrigger',
    props: {
      value: {
        required: true,
      },
      entityType: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        checkConditions: false,
        getEntityToRetry: false,
      }
    },
    computed: {
      show: {
        get() {
          return this.value
        },
        set(value) {
          this.$emit('input', value)
        },
      },
      displayGetEntityToRetryButton() {
        const entitiesNotToGet = ['stockParsing']
        return !entitiesNotToGet.includes(this.entityType)
      },
    },
    methods: {
      validate() {
        this.$emit('confirm', { checkConditions: this.checkConditions, getEntityToRetry: this.getEntityToRetry })
      },
      close() {
        this.$emit('close')
      },
    },
  }
</script>
